import Phaser from 'phaser';
import { ResponsiveSystem } from '../systems/ResponsiveSystem';
import { UIStyle } from '../ui/UIStyle';

interface ZoneHeaderEntry {
  title: Phaser.GameObjects.Text;
  subtitle: Phaser.GameObjects.Text;
}

const zoneHeaderEntries: ZoneHeaderEntry[] = [];

/** Pulihkan visibilitas HUD zona setelah restart/transisi. */
export function resetZoneHudVisibility(): void {
  setZoneHeaderVisible(true);
}

/** Sembunyikan judul zona saat panel modal terbuka */
export function setZoneHeaderVisible(visible: boolean): void {
  zoneHeaderEntries.forEach(({ title, subtitle }) => {
    title.setVisible(visible);
    subtitle.setVisible(visible);
  });
}

function relayoutEntry(entry: ZoneHeaderEntry, scene: Phaser.Scene): void {
  const isMobile = ResponsiveSystem.isMobile(scene);
  const safe = ResponsiveSystem.getSafeBounds(scene.game, {
    top: isMobile ? 18 : 20,
    bottom: isMobile ? 88 : 20,
  });
  const centerX = safe.centerX;
  const titleY = safe.top + (isMobile ? 8 : 4);
  const subtitleY = titleY + (isMobile ? 30 : 36);

  entry.title.setPosition(centerX, titleY);
  entry.title.setStyle({
    ...UIStyle.onBrightBg(isMobile ? UIStyle.px(22) : UIStyle.px(30), '#ffffff', true),
    align: 'center',
    wordWrap: { width: Math.min(840, safe.width) },
  });

  entry.subtitle.setPosition(centerX, subtitleY);
  entry.subtitle.setStyle({
    ...UIStyle.onBrightBg(isMobile ? UIStyle.px(14) : UIStyle.px(16), UIStyle.accentColor(), true),
    align: 'center',
    wordWrap: { width: Math.min(860, safe.width) },
  });
}

/** Judul zona + subtitle — kontras tinggi di background terang */
export function addZoneHudHeader(
  scene: Phaser.Scene,
  zoneTitle: string,
  subtitle: string,
): void {
  const isMobile = ResponsiveSystem.isMobile(scene);
  const safe = ResponsiveSystem.getSafeBounds(scene.game, {
    top: isMobile ? 18 : 20,
    bottom: isMobile ? 88 : 20,
  });
  const centerX = safe.centerX;
  const titleY = safe.top + (isMobile ? 8 : 4);
  const subtitleY = titleY + (isMobile ? 30 : 36);

  const title = scene.add.text(centerX, titleY, zoneTitle, {
    ...UIStyle.onBrightBg(isMobile ? UIStyle.px(22) : UIStyle.px(30), '#ffffff', true),
    align: 'center',
    wordWrap: { width: Math.min(840, safe.width) },
  }).setOrigin(0.5, 0).setScrollFactor(0).setDepth(40);

  const sub = scene.add.text(centerX, subtitleY, subtitle, {
    ...UIStyle.onBrightBg(isMobile ? UIStyle.px(14) : UIStyle.px(16), UIStyle.accentColor(), true),
    align: 'center',
    wordWrap: { width: Math.min(860, safe.width) },
  }).setOrigin(0.5, 0).setScrollFactor(0).setDepth(40);

  const entry: ZoneHeaderEntry = { title, subtitle: sub };
  zoneHeaderEntries.push(entry);

  const unbindResize = ResponsiveSystem.onResize(() => relayoutEntry(entry, scene));

  scene.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
    const idx = zoneHeaderEntries.indexOf(entry);
    if (idx >= 0) zoneHeaderEntries.splice(idx, 1);
    unbindResize();
  });
}
